<template>
  <a-card :bordered="false">
    <a-row :gutter="24">
      <a-col :span="24">
        <!-- 条件搜索区域 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline">
            <a-row :gutter="48">
              <a-col :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="8">
                <a-form-item label="空间ID" prop="spaceId">
                  <a-input
                    v-model:value="queryParam.spaceId"
                    placeholder="请输入"
                    allow-clear
                    class="no-border-radius-input"
                  />
                </a-form-item>
              </a-col>
              <a-col :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="8">
                <a-form-item label="日期" prop="stayDate">
                  <a-date-picker
                    v-model:value="queryParam.stayDate"
                    style="width: 100%"
                    format="YYYY-MM-DD"
                    valueFormat="YYYY-MM-DD"
                    placeholder="请选择"
                    allow-clear
                    class="no-border-radius-picker"
                  />
                </a-form-item>
              </a-col>
              <a-col :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="8">
                <a-form-item label="空间名称" prop="spaceName">
                  <a-input
                    v-model:value="queryParam.spaceName"
                    placeholder="请输入"
                    allow-clear
                    class="no-border-radius-input"
                  />
                </a-form-item>
              </a-col>

              <!-- 按钮区域：默认在第一行，展开后在最后一行 -->
              <a-col v-if="!advanced" :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="8">
                <a-form-item>
                  <span class="table-page-search-submitButtons" :style="submitButtonStyle">
                    <a-button type="primary" @click="handleQuery" class="search-button">搜索</a-button>
                    <a-button style="margin-left: 8px" @click="resetQuery" class="no-border-button">重置</a-button>
                    <a-button style="margin-left: 8px" @click="toggleAdvanced" class="no-border-button toggle-button">
                      {{ advanced ? '收起' : '展开' }}
                      <UpOutlined v-if="advanced" />
                      <DownOutlined v-else />
                    </a-button>
                  </span>
                </a-form-item>
              </a-col>

              <!-- 高级搜索：补充剩余字段 -->
              <template v-if="advanced">
                <a-col :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="8">
                  <a-form-item label="员工姓名" prop="employeeName">
                    <a-input
                      v-model:value="queryParam.employeeName"
                      placeholder="请输入"
                      allow-clear
                      class="no-border-radius-input"
                    />
                  </a-form-item>
                </a-col>
                <a-col :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="8">
                  <a-form-item label="总时长(分钟)" prop="stayDuration">
                    <a-input-number
                      v-model:value="queryParam.stayDuration"
                      :min="0"
                      :step="1"
                      placeholder="请输入"
                      class="no-border-radius-input-number"
                    />
                  </a-form-item>
                </a-col>
                <a-col :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="8">
                  <a-form-item label="进入次数" prop="stayTimes">
                    <a-input-number
                      v-model:value="queryParam.stayTimes"
                      :min="0"
                      :step="1"
                      placeholder="请输入"
                      class="no-border-radius-input-number"
                    />
                  </a-form-item>
                </a-col>
                <a-col :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="8">
                  <a-form-item label="平均时长(分钟)" prop="avgDuration">
                    <a-input-number
                      v-model:value="queryParam.avgDuration"
                      :min="0"
                      :step="1"
                      placeholder="请输入"
                      class="no-border-radius-input-number"
                    />
                  </a-form-item>
                </a-col>
                <a-col :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="8">
                  <a-form-item label="空间性质" prop="spatialProperties">
                    <a-select
                      v-model:value="queryParam.spatialProperties"
                      placeholder="请选择"
                      allow-clear
                      style="width: 100%"
                      class="no-border-radius-select"
                    >
                      <a-select-option
                        v-for="dict in dict.type['spatial_properties']"
                        :key="dict.value"
                        :value="dict.value"
                      >
                        {{ dict.label }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="8">
                  <a-form-item label="所属项目" prop="projectName">
                    <a-input
                      v-model:value="queryParam.projectName"
                      placeholder="请输入"
                      allow-clear
                      class="no-border-radius-input"
                    />
                  </a-form-item>
                </a-col>
                <a-col :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="8">
                  <a-form-item label="所属公司" prop="companyName">
                    <a-input
                      v-model:value="queryParam.companyName"
                      placeholder="请输入"
                      allow-clear
                      class="no-border-radius-input"
                    />
                  </a-form-item>
                </a-col>

                <!-- 展开后，按钮在最后一行 -->
                <a-col :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="8">
                  <a-form-item :label-col="{ span: 0 }" :wrapper-col="{ span: 24 }">
                    <span class="table-page-search-submitButtons" :style="submitButtonStyle">
                      <a-button type="primary" @click="handleQuery" class="search-button">搜索</a-button>
                      <a-button style="margin-left: 8px" @click="resetQuery" class="no-border-button">重置</a-button>
                      <a-button style="margin-left: 8px" @click="toggleAdvanced" class="no-border-button toggle-button">
                        {{ advanced ? '收起' : '展开' }}
                        <UpOutlined v-if="advanced" />
                        <DownOutlined v-else />
                      </a-button>
                    </span>
                  </a-form-item>
                </a-col>
              </template>
            </a-row>
          </a-form>
        </div>
        <!-- 操作按钮区域 -->
        <div class="table-operations">
          <a-button
            type="text"
            shape="circle"
            @click="getList"
            v-hasPermi="['system:spaceStay:refresh']"
            class="refresh-icon-button"
          >
            <img src="@/assets/images/projectUser/refresh.png" alt="刷新" />
          </a-button>
          <a-button
            @click="handleExport"
            v-hasPermi="['system:spaceStay:export']"
            class="no-border-button export-button"
          >
            <UploadOutlined />导出
          </a-button>
          <a-button
            :disabled="multiple"
            @click="handleDelete"
            v-hasPermi="['system:spaceStay:remove']"
            class="no-border-button delete-button"
          >
            <DeleteOutlined />删除
          </a-button>
          <!-- <table-setting
            :style="{ float: 'right' }"
            v-model:table-size="tableSize"
            v-model:value="columns"
            :refresh-loading="loading"
            @refresh="getList"
          /> -->
        </div>
        <!-- 组件 -->
        <create-form ref="createForm" @ok="getList" @close="getList" />
        <space-stay-record
          :visible="recordVisible"
          :stayId="currentRecord.stayId"
          :projectId="currentRecord.projectId"
          :companyId="currentRecord.companyId"
          :spaceId="currentRecord.spaceId"
          :spaceName="currentRecord.spaceName"
          :employeeId="currentRecord.employeeId"
          :employeeName="currentRecord.employeeName"
          :stayDate="currentRecord.stayDate"
          @close="handleCloseRecord"
        />
        <!-- 数据表格 -->
        <div style="margin-top: 20px">
          <a-table
            :loading="loading"
            :size="tableSize"
            rowKey="id"
            :columns="tableColumns"
            :data-source="list"
            :row-selection="{
              selectedRowKeys: selectedRowKeys,
              onChange: onSelectChange,
            }"
            :pagination="false"
            :bordered="tableBordered"
            :scroll="{ x: 2000 }"
            class="optimized-table"
          >
            <template #bodyCell="{ column, text, record, index }">
              <!-- 序号列 -->
              <template v-if="column.dataIndex === 'id'">
                <span>{{
                  (queryParam.pageNum - 1) * queryParam.pageSize +
                  (index !== undefined && index !== null ? index : list.findIndex((item) => item.id === record.id)) +
                  1
                }}</span>
              </template>
              <!-- 空间性质 -->
              <template v-else-if="column.dataIndex === 'spatialProperties'">
                <span>{{ getDictLabel(dict.type['spatial_properties'], text) || text }}</span>
              </template>
              <!-- 操作列 -->
              <template v-else-if="column.dataIndex === 'operation'">
                <div class="table-action-buttons">
                  <a @click="handleShowRecord(record)" v-hasPermi="['system:spaceStay:record']" class="edit-link">
                    服务时长明细
                  </a>
                  <span class="action-divider">|</span>
                  <a @click="handleDelete(record)" v-hasPermi="['system:spaceStay:remove']" class="delete-link">
                    删除
                  </a>
                </div>
              </template>
              <!-- 其他字段：默认显示 text 值 -->
              <template v-else>
                <span>{{ text }}</span>
              </template>
            </template>
          </a-table>
        </div>
        <!-- 分页 -->
        <div class="pagination-wrapper">
          <div class="pagination-left">
            <span class="pagination-info">
              显示第 {{ (queryParam.pageNum - 1) * queryParam.pageSize + 1 }} 到第
              {{ Math.min(queryParam.pageNum * queryParam.pageSize, total) }} 条数据/共 {{ total }} 条
            </span>
            <a-select
              v-model:value="queryParam.pageSize"
              style="width: 100px; margin-left: 8px"
              @change="onShowSizeChange(queryParam.pageNum, queryParam.pageSize)"
              class="no-border-radius-select"
            >
              <a-select-option :value="10">10条/页</a-select-option>
              <a-select-option :value="20">20条/页</a-select-option>
              <a-select-option :value="50">50条/页</a-select-option>
              <a-select-option :value="100">100条/页</a-select-option>
            </a-select>
          </div>
          <div class="pagination-right">
            <a-pagination
              :current="queryParam.pageNum"
              :total="total"
              :page-size="queryParam.pageSize"
              :show-total="false"
              @change="changeSize"
            />
            <span class="pagination-jump">
              到第
              <a-input-number
                v-model:value="jumpPage"
                :min="1"
                :max="Math.ceil(total / queryParam.pageSize)"
                style="width: 60px; margin: 0 4px"
                @pressEnter="handleJumpPage"
                class="no-border-radius-input-number"
              />
              页
            </span>
          </div>
        </div>
      </a-col>
    </a-row>
  </a-card>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../utils/gogocodeTransfer'
import {
  SearchOutlined,
  RedoOutlined,
  UpOutlined,
  DownOutlined,
  DeleteOutlined,
  UploadOutlined,
} from '@ant-design/icons-vue'
import { pageSpaceStay, delSpaceStay } from '@/api/system/spaceStay'
import CreateForm from './modules/CreateForm'
import SpaceStayRecord from './modules/SpaceStayRecord'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'SpaceStay',
  dicts: ['spatial_properties'],
  components: {
    SearchOutlined,
    RedoOutlined,
    UpOutlined,
    DownOutlined,
    DeleteOutlined,
    UploadOutlined,
    CreateForm,
    SpaceStayRecord,
  },
  mixins: [tableMixin],
  data() {
    return {
      // 页面状态
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      jumpPage: 1,
      // 服务时长明细弹窗状态
      recordVisible: false,
      // 当前选中的记录（用于传递给明细弹窗）
      currentRecord: {
        stayId: null,
        projectId: null,
        companyId: null,
        spaceId: null,
        spaceName: null,
        employeeId: null,
        employeeName: null,
        stayDate: null,
      },
      // 查询参数（字段顺序与表格保持一致）
      queryParam: {
        spaceId: null,
        stayDate: null,
        spaceName: null,
        employeeName: null,
        stayDuration: null,
        stayTimes: null,
        avgDuration: null,
        spatialProperties: undefined,
        projectId: null, // 项目ID（从Vuex获取）
        projectName: null,
        companyName: null,
        pageNum: 1,
        pageSize: 10,
      },
      columns: [
        {
          title: '空间ID',
          dataIndex: 'spaceId',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '日期',
          dataIndex: 'stayDate',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '空间名称',
          dataIndex: 'spaceName',
          ellipsis: false,
          align: 'left',
          customCell: () => ({
            style: {
              minWidth: '600px',
              whiteSpace: 'nowrap',
              overflow: 'visible',
              textOverflow: 'clip',
            },
          }),
        },
        {
          title: '员工姓名',
          dataIndex: 'employeeName',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '进入次数',
          dataIndex: 'stayTimes',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '总时长(分钟)',
          dataIndex: 'stayDuration',
          ellipsis: true,
          align: 'center',
        },

        {
          title: '平均时长(分钟)',
          dataIndex: 'avgDuration',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '空间性质',
          dataIndex: 'spatialProperties',
          ellipsis: true,
          align: 'center',
        },

        {
          title: '当前所属项目',
          dataIndex: 'projectName',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '所属公司',
          dataIndex: 'companyName',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 200,
          align: 'center',
          fixed: 'right',
        },
      ],
    }
  },
  created() {
    // 初始化时从 Vuex 获取项目ID
    const currentProjectId = this.$store.getters.currentProjectId
    if (currentProjectId) {
      this.queryParam.projectId = currentProjectId
    }
    // 页面创建时加载数据列表
    this.getList()
    // 监听项目变化事件（使用 $root 事件总线）
    $on(this.$root, 'project-changed', this.handleProjectChanged)
  },
  beforeUnmount() {
    // 移除事件监听
    $off(this.$root, 'project-changed', this.handleProjectChanged)
  },
  computed: {
    submitButtonStyle() {
      return this.advanced ? {} : {}
    },
    // 表格列配置（使用 computed 以便在 customRender 中访问 this）
    tableColumns() {
      const that = this
      return [
        {
          title: '序号',
          dataIndex: 'id',
          width: 80,
          align: 'center',
          customRender: ({ index }) => {
            const pageNum = that.queryParam.pageNum || 1
            const pageSize = that.queryParam.pageSize || 10
            const currentIndex = index !== undefined && index !== null ? Number(index) : 0
            if (isNaN(currentIndex) || isNaN(pageNum) || isNaN(pageSize)) {
              return currentIndex + 1
            }
            return (pageNum - 1) * pageSize + currentIndex + 1
          },
        },
        ...this.columns, // 保留其他列配置
      ]
    },
  },
  watch: {},
  methods: {
    /** 查询空间停留汇总列表 */
    getList() {
      // 每次查询前同步 Vuex 中的当前项目ID
      const currentProjectId = this.$store.getters.currentProjectId
      if (currentProjectId) {
        this.queryParam.projectId = currentProjectId
      }
      this.loading = true
      pageSpaceStay(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.jumpPage = this.queryParam.pageNum
        this.loading = false
      })
    },
    /**
     * 处理项目变化事件
     * 当右侧项目选择发生变化时，更新查询参数并刷新列表
     * @param {Number} projectId - 新选中的项目ID（可能为 undefined，表示清空选择）
     */
    handleProjectChanged(projectId) {
      // 更新查询参数中的项目ID
      this.queryParam.projectId = projectId || undefined
      // 重置到第一页并刷新列表
      this.queryParam.pageNum = 1
      this.getList()
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      // 从 Vuex 获取当前项目ID作为默认值
      const currentProjectId = this.$store.getters.currentProjectId
      this.queryParam = {
        spaceId: undefined,
        stayDate: undefined,
        spaceName: undefined,
        employeeName: undefined,
        stayDuration: undefined,
        stayTimes: undefined,
        avgDuration: undefined,
        spatialProperties: undefined,
        projectId: currentProjectId || undefined,
        projectName: undefined,
        companyName: undefined,
        pageNum: 1,
        pageSize: 10,
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.queryParam.pageNum = 1
      this.jumpPage = 1
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.jumpPage = current
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /**
     * 获取字典标签
     * @param {Array} dictList 字典列表
     * @param {String|Number} value 字典值
     * @returns {String} 字典文字
     */
    getDictLabel(dictList, value) {
      if (value === null || value === undefined || value === '') {
        return '-'
      }
      if (!dictList || !Array.isArray(dictList) || dictList.length === 0) {
        return String(value)
      }

      // 将值转换为数字和字符串两种形式进行匹配
      const valueNum = typeof value === 'number' ? value : Number(value)
      const valueStr = String(value)
      const isValueNumeric = !isNaN(valueNum) && valueNum !== null

      // 查找匹配的字典项
      const dictItem = dictList.find((item) => {
        if (!item || item.value === undefined || item.value === null) {
          return false
        }
        const itemValue = item.value
        const itemValueNum = typeof itemValue === 'number' ? itemValue : Number(itemValue)
        const itemValueStr = String(itemValue)
        const isItemNumeric = !isNaN(itemValueNum) && itemValueNum !== null

        // 1. 严格相等匹配
        if (itemValue === value) {
          return true
        }
        // 2. 字符串匹配
        if (itemValueStr === valueStr) {
          return true
        }
        // 3. 数字匹配（如果都是有效数字）
        if (isValueNumeric && isItemNumeric && itemValueNum === valueNum) {
          return true
        }
        return false
      })

      if (dictItem && dictItem.label) {
        return dictItem.label
      }

      return String(value)
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      // 获取要删除的空间名称
      let spaceNames = []
      if (row && row.id) {
        // 单条删除
        spaceNames = [row.spaceName || '未知空间']
      } else {
        // 批量删除
        spaceNames = this.selectedRows.map((item) => item.spaceName || '未知空间')
      }
      const spaceNamesText = spaceNames.length > 0 ? spaceNames.join('、') : '未知空间'
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中空间名称为：' + spaceNamesText + ' 的数据',
        onOk() {
          let data = []
          that.ids.map((id) => data.push({ id: id }))
          return delSpaceStay(data).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() {
          //取消清空删除ids列表
          that.ids = []
        },
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      const that = this
      const hasSelection = this.selectedRowKeys && this.selectedRowKeys.length > 0
      this.$confirm({
        title: '是否确认导出?',
        content: hasSelection ? '将导出所选空间停留数据' : '将导出当前条件下的全部数据',
        onOk() {
          const params = {
            ...that.queryParam,
          }
          if (hasSelection) {
            params.ids = that.selectedRowKeys
          }
          that.download('system/space-stay/export', params, `空间停留汇总_${new Date().getTime()}.xlsx`)
        },
        onCancel() {},
      })
    },
    /** 显示服务时长明细弹窗 */
    handleShowRecord(record) {
      this.currentRecord = {
        stayId: record.id || record.stayId || null,
        projectId: record.projectId || null,
        companyId: record.companyId || null,
        spaceId: record.spaceId || null,
        spaceName: record.spaceName || null,
        employeeId: record.employeeId || null,
        employeeName: record.employeeName || null,
        stayDate: record.stayDate || null,
      }
      this.recordVisible = true
    },
    /** 关闭服务时长明细弹窗 */
    handleCloseRecord() {
      this.recordVisible = false
      this.currentRecord = {
        stayId: null,
        projectId: null,
        companyId: null,
        spaceId: null,
        spaceName: null,
        employeeId: null,
        employeeName: null,
        stayDate: null,
      }
    },
    /** 跳转到指定页码 */
    handleJumpPage() {
      if (this.jumpPage && this.jumpPage >= 1) {
        const maxPage = Math.ceil(this.total / this.queryParam.pageSize)
        if (this.jumpPage > maxPage) {
          this.jumpPage = maxPage
        }
        this.queryParam.pageNum = this.jumpPage
        this.getList()
      }
    },
  },
}
</script>

<style scoped>
/* 条件搜索区域样式 */
.table-page-search-wrapper :deep(.ant-form-item-label) {
  width: 100px;
  min-width: 100px;
}

.table-page-search-wrapper :deep(.ant-form-item-label > label) {
  width: 100px;
  text-align: right;
}

/* 搜索栏 FormItem 布局：左侧文字固定 100px，右侧输入区域自适应 */
.table-page-search-wrapper :deep(.ant-form-item) {
  display: flex;
  align-items: center;
  width: 100%;
}

.table-page-search-wrapper :deep(.ant-form-item-label) {
  flex: 0 0 100px;
}

.table-page-search-wrapper :deep(.ant-form-item-control) {
  flex: 1 1 auto;
  margin-left: 8px;
}

/* 移除所有输入框圆角的通用样式 */
.no-border-radius-input :deep(.ant-input) {
  border-radius: 0 !important;
}

.no-border-radius-input :deep(.ant-input-affix-wrapper) {
  border-radius: 0 !important;
}

.no-border-radius-picker :deep(.ant-picker) {
  border-radius: 0 !important;
}

.no-border-radius-select :deep(.ant-select-selector) {
  border-radius: 0 !important;
}

.no-border-radius-input-number :deep(.ant-input-number) {
  border-radius: 0 !important;
}

.no-border-radius-input-number :deep(.ant-input-number-input) {
  border-radius: 0 !important;
}

/* 搜索区域输入框样式覆盖 - 优先级高于 no-border-radius-input */
/* 普通输入框样式 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input),
.table-page-search-wrapper :deep(.ant-form-item-control-input .ant-input) {
  width: 100% !important;
  background: #ffffff !important;
  border-radius: 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 带前缀/后缀的输入框外层样式 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper) {
  width: 100% !important;
  background: #ffffff !important;
  border-radius: 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 带前缀/后缀的输入框内部input去掉边框，避免嵌套 */
/* 通用规则：当 input 在 affix-wrapper 内时，必须去掉边框避免嵌套 - 最高优先级 */
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper > .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper input.ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input:hover),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input:focus),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input:not(:focus):not(:hover)),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper .ant-input),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper > .ant-input),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper .ant-input:hover),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper .ant-input:focus),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper .ant-input-focused),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input[type='text']) {
  border: 0 !important;
  border-top: 0 !important;
  border-right: 0 !important;
  border-bottom: 0 !important;
  border-left: 0 !important;
  border-width: 0 !important;
  border-style: none !important;
  border-color: transparent !important;
  background: transparent !important;
  background-color: transparent !important;
  box-shadow: none !important;
  outline: none !important;
  width: 100% !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
}

/* 移除搜索栏输入框、下拉选择框、日期选择框聚焦时的高亮效果 */
/* 输入框聚焦样式 - 内部input隐藏边框 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input:focus),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-focused),
.table-page-search-wrapper :deep(.ant-input:focus),
.table-page-search-wrapper :deep(.ant-input-focused) {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 带前缀/后缀的输入框聚焦样式 - 外部容器保持边框，内部input隐藏边框 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper:focus),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper-focused),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper:focus),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper-focused) {
  border: 1px solid #c7c7c7 !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 聚焦时，内部input隐藏边框 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper:focus .ant-input),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper-focused .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper:focus .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper-focused .ant-input) {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 下拉选择框聚焦样式 */
.table-page-search-wrapper :deep(.no-border-radius-select .ant-select-selector:focus),
.table-page-search-wrapper :deep(.no-border-radius-select .ant-select-focused .ant-select-selector),
.table-page-search-wrapper :deep(.ant-select-selector:focus),
.table-page-search-wrapper :deep(.ant-select-focused .ant-select-selector) {
  border: 1px solid #c7c7c7 !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 日期选择框聚焦样式 */
.table-page-search-wrapper :deep(.no-border-radius-picker .ant-picker:focus),
.table-page-search-wrapper :deep(.no-border-radius-picker .ant-picker-focused),
.table-page-search-wrapper :deep(.ant-picker:focus),
.table-page-search-wrapper :deep(.ant-picker-focused) {
  border: 1px solid #c7c7c7 !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 日期选择器样式 */
.table-page-search-wrapper :deep(.no-border-radius-picker .ant-picker),
.table-page-search-wrapper :deep(.ant-picker) {
  width: 100% !important;
  min-width: auto !important;
  max-width: 100% !important;
  background: #ffffff !important;
  border-radius: 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 下拉选择框样式 */
.table-page-search-wrapper :deep(.no-border-radius-select .ant-select-selector),
.table-page-search-wrapper :deep(.ant-select-selector) {
  width: 100% !important;
  min-width: auto !important;
  max-width: 100% !important;
  background: #ffffff !important;
  border-radius: 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 下拉选择框容器样式 */
.table-page-search-wrapper :deep(.no-border-radius-select.ant-select),
.table-page-search-wrapper :deep(.ant-select) {
  width: 100% !important;
  min-width: auto !important;
  max-width: 100% !important;
}

.table-page-search-wrapper :deep(.ant-input-number) {
  width: 100% !important;
  border-radius: 4px 4px 4px 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 搜索区域数字输入框样式 */
.table-page-search-wrapper :deep(.no-border-radius-input-number.ant-input-number),
.table-page-search-wrapper :deep(.no-border-radius-input-number) {
  border-radius: 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 搜索按钮和新增按钮样式 */
.search-button,
.add-button {
  background-color: #165dff !important;
  border-color: #165dff !important;
  border-radius: 4px !important;
}

.search-button:hover,
.add-button:hover {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
}

.search-button:focus,
.add-button:focus {
  background-color: #165dff !important;
  border-color: #165dff !important;
}

/* 其他按钮圆角设置 */
.table-page-search-wrapper :deep(.ant-btn) {
  border-radius: 4px;
}

/* 按钮区域样式 */
.table-page-search-submitButtons {
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: flex-start;
}

.table-operations :deep(.ant-btn) {
  border-radius: 4px;
}

/* 全局按钮圆角设置 */
:deep(.ant-btn) {
  border-radius: 4px !important;
}

.table-action-buttons a {
  color: #1890ff;
  cursor: pointer;
  white-space: nowrap; /* 防止操作按钮换行 */
}

.table-action-buttons a:hover {
  color: #40a9ff;
}

/* 编辑按钮颜色 */
.table-action-buttons .edit-link {
  color: #165dff !important;
}

.table-action-buttons .edit-link:hover {
  color: #4080ff !important;
}

/* 删除按钮颜色 - 红色 */
.table-action-buttons .delete-link {
  color: #ff4d4f !important;
}

.table-action-buttons .delete-link:hover {
  color: #ff7875 !important;
}

.action-divider {
  margin: 0 8px;
  color: #d9d9d9;
  white-space: nowrap;
}

/* 去掉指定按钮的边框 */
.no-border-button {
  border: none !important;
  background-color: #f3f3f3 !important;
  color: #101010 !important;
}

.no-border-button:hover,
.no-border-button:focus {
  border: none !important;
  background-color: #f3f3f3 !important;
  color: #101010 !important;
}

/* 删除按钮样式 - 参照 projectUser 页面的修改状态按钮 */
.delete-button {
  font-family: PingFang SC, PingFang SC !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #333333 !important;
}

.delete-button:hover,
.delete-button:focus {
  color: #333333 !important;
}

.delete-button:disabled {
  color: rgba(0, 0, 0, 0.25) !important;
}

/* 导出按钮样式 */
.export-button {
  background-color: #f3f3f3 !important;
  border-color: #f3f3f3 !important;
  color: #333333 !important;
}

.export-button :deep(.anticon) {
  color: #333333 !important;
}

.export-button:hover:not(:disabled) {
  background-color: #e6e6e6 !important;
  border-color: #e6e6e6 !important;
  color: #333333 !important;
}

.export-button:hover:not(:disabled) :deep(.anticon) {
  color: #333333 !important;
}

.export-button:focus:not(:disabled) {
  background-color: #f3f3f3 !important;
  border-color: #f3f3f3 !important;
  color: #333333 !important;
}

.export-button:focus:not(:disabled) :deep(.anticon) {
  color: #333333 !important;
}

/* 展开/收起按钮文字和图标颜色，去掉底部阴影 */
.toggle-button {
  color: #165dff !important;
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
}

.toggle-button :deep(.anticon) {
  color: #165dff !important;
}

.toggle-button:hover,
.toggle-button:focus {
  color: #165dff !important;
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
}

.toggle-button:hover :deep(.anticon),
.toggle-button:focus :deep(.anticon) {
  color: #165dff !important;
}

.table-page-search-wrapper {
  margin-bottom: 16px;
}

.table-operations {
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.refresh-icon-button {
  width: 32px;
  height: 32px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pagination-wrapper {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pagination-left {
  display: flex;
  align-items: center;
}

.pagination-info {
  color: rgba(0, 0, 0, 0.65);
}

.pagination-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.pagination-jump {
  display: flex;
  align-items: center;
  color: rgba(0, 0, 0, 0.65);
}

/* 分页组件样式 - 去掉圆角 */
.pagination-wrapper :deep(.ant-btn) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-pagination-item) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-pagination-prev),
.pagination-wrapper :deep(.ant-pagination-next),
.pagination-wrapper :deep(.ant-pagination-prev .ant-pagination-item-link),
.pagination-wrapper :deep(.ant-pagination-next .ant-pagination-item-link) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-pagination-prev button),
.pagination-wrapper :deep(.ant-pagination-next button) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-input-number) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-input-number-input) {
  border-radius: 0 !important;
  color: #000000 !important;
}

.pagination-wrapper :deep(.ant-input-number-input input) {
  color: #000000 !important;
}

/* 分页选中页数样式 */
.pagination-wrapper :deep(.ant-pagination-item-active) {
  background: #165dff !important;
  border-color: #165dff !important;
  border-radius: 4px !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active a) {
  color: #ffffff !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active:hover) {
  background: #165dff !important;
  border-color: #165dff !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active:hover a) {
  color: #ffffff !important;
}

/* 优化表格样式 */
.optimized-table :deep(.ant-table-thead > tr > th) {
  white-space: nowrap; /* 表头不换行 */
  overflow: hidden;
  text-overflow: ellipsis;
  background-color: #fafafa;
  font-family: PingFang SC, PingFang SC;
  font-weight: bold;
  font-size: 14px;
  color: #333333;
}

.optimized-table :deep(.ant-table-tbody > tr > td) {
  white-space: nowrap; /* 表格内容不换行 */
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 12px 8px; /* 增加内边距 */
  font-family: PingFang SC, PingFang SC !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #333333 !important;
}

/* 操作列固定右侧样式 */
.optimized-table :deep(.ant-table-tbody > tr > td:last-child) {
  position: sticky;
  right: 0;
  background: white;
  z-index: 1;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.05);
}

.optimized-table :deep(.ant-table-thead > tr > th:last-child) {
  position: sticky;
  right: 0;
  background: #fafafa;
  z-index: 2;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.05);
}

/* 行悬停效果 */
.optimized-table :deep(.ant-table-tbody > tr:hover > td) {
  background-color: #f5f5f5;
}

/* 去掉表格边框 */
:deep(.ant-table) {
  border: none !important;
}

:deep(.ant-table-container) {
  border: none !important;
}

:deep(.ant-table-thead > tr > th) {
  border-bottom: 1px solid #f0f0f0 !important;
  border-right: none !important;
}

:deep(.ant-table-thead > tr > th:first-child) {
  border-left: none !important;
}

:deep(.ant-table-tbody > tr > td) {
  border-bottom: 1px solid #f0f0f0 !important;
  border-right: none !important;
}

:deep(.ant-table-tbody > tr > td:first-child) {
  border-left: none !important;
}

:deep(.ant-table-tbody > tr:last-child > td) {
  border-bottom: none !important;
}

/* 表格滚动条样式优化 */
:deep(.ant-table-body) {
  overflow-x: auto !important;
  scrollbar-width: thin;
  scrollbar-color: #d9d9d9 #f5f5f5;
}

:deep(.ant-table-body::-webkit-scrollbar) {
  height: 8px;
}

:deep(.ant-table-body::-webkit-scrollbar-track) {
  background: #f5f5f5;
  border-radius: 4px;
}

:deep(.ant-table-body::-webkit-scrollbar-thumb) {
  background: #d9d9d9;
  border-radius: 4px;
}

:deep(.ant-table-body::-webkit-scrollbar-thumb:hover) {
  background: #bfbfbf;
}

/* 序号列样式优化 */
:deep(.ant-table-tbody > tr > td:first-child) {
  font-family: PingFang SC, PingFang SC !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #333333 !important;
}

/* 选中的行样式 - 去掉背景色 */
:deep(.ant-table-tbody > tr.ant-table-row-selected > td) {
  background-color: transparent !important;
}

:deep(.ant-table-tbody > tr.ant-table-row-selected:hover > td) {
  background-color: transparent !important;
}

/* 表格复选框样式 */
.optimized-table :deep(.ant-checkbox-inner) {
  width: 16px !important;
  height: 16px !important;
  border-radius: 0 !important;
  border-color: #999999 !important;
}

.optimized-table :deep(.ant-checkbox-checked .ant-checkbox-inner) {
  background-color: #165dff !important;
  border-color: #165dff !important;
}

.optimized-table :deep(.ant-checkbox-checked .ant-checkbox-inner::after) {
  border-color: #ffffff !important;
}

.optimized-table :deep(.ant-checkbox:hover .ant-checkbox-inner) {
  border-color: #165dff !important;
}

.optimized-table :deep(.ant-checkbox-input:focus + .ant-checkbox-inner) {
  border-color: #165dff !important;
}

.optimized-table :deep(.ant-checkbox-checked:hover .ant-checkbox-inner) {
  background-color: #165dff !important;
  border-color: #165dff !important;
}

/* 全选按钮indeterminate状态：改为蓝色 */
.optimized-table :deep(.ant-checkbox-indeterminate .ant-checkbox-inner) {
  background-color: #165dff !important;
  border-color: #165dff !important;
}

.optimized-table :deep(.ant-checkbox-indeterminate .ant-checkbox-inner::after) {
  background-color: #ffffff !important;
  border-top-color: #ffffff !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  border-left-color: transparent !important;
}

.optimized-table :deep(.ant-checkbox-indeterminate:hover .ant-checkbox-inner) {
  background-color: #165dff !important;
  border-color: #165dff !important;
}

/* Confirm 弹窗按钮样式 */
:deep(.ant-modal-confirm .ant-btn) {
  border-radius: 4px !important;
}

:deep(.ant-modal-confirm .ant-btn-default) {
  border-radius: 4px !important;
}

:deep(.ant-modal-confirm .ant-btn-primary) {
  background-color: #165dff !important;
  border-color: #165dff !important;
  border-radius: 4px !important;
  color: #ffffff !important;
}

:deep(.ant-modal-confirm .ant-btn-primary:hover:not(:disabled)) {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
  color: #ffffff !important;
}

:deep(.ant-modal-confirm .ant-btn-primary:focus:not(:disabled)) {
  background-color: #165dff !important;
  border-color: #165dff !important;
  color: #ffffff !important;
}

:deep(.ant-modal-confirm .ant-btn-primary:active:not(:disabled)) {
  background-color: #165dff !important;
  border-color: #165dff !important;
  color: #ffffff !important;
}
</style>

<style>
/* Confirm 弹窗按钮样式 - 全局样式确保生效（confirm弹窗是动态创建的） */
.ant-modal-confirm .ant-modal-confirm-btns .ant-btn {
  border-radius: 4px !important;
}

.ant-modal-confirm .ant-modal-confirm-btns .ant-btn-default {
  border-radius: 4px !important;
}

.ant-modal-confirm .ant-modal-confirm-btns .ant-btn-primary {
  background-color: #165dff !important;
  border-color: #165dff !important;
  border-radius: 4px !important;
  color: #ffffff !important;
}

.ant-modal-confirm .ant-modal-confirm-btns .ant-btn-primary:hover:not(:disabled) {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
  color: #ffffff !important;
}

.ant-modal-confirm .ant-modal-confirm-btns .ant-btn-primary:focus:not(:disabled) {
  background-color: #165dff !important;
  border-color: #165dff !important;
  color: #ffffff !important;
}

.ant-modal-confirm .ant-modal-confirm-btns .ant-btn-primary:active:not(:disabled) {
  background-color: #165dff !important;
  border-color: #165dff !important;
  color: #ffffff !important;
}
</style>
